import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Breadcrumbs, InformationModal, Text } from '@components';
import { CHANGE_PASSWORD_SCHEMA, CHANGE_USERNAME_SCHEMA, getProfileFormConfig } from '@constants';
import { FormType, ProfileEndpoint, Translation } from '@enums';
import { useAppDispatch, useCreateModal } from '@hooks';
import { submitFormRequest, useUserDetails } from '@store';
import { validateDataValue } from '@utils';

import { ProfileSettingsForm } from './subLayer';

export const ProfileSettings = () => {
  const { id: application_id } = useParams();
  const dispatch = useAppDispatch();
  const userDetails = useUserDetails();
  const formType = FormType.Profile;

  const { t: tModals } = useTranslation(Translation.ProfileSettings, { keyPrefix: 'modals' });

  const [openVerifyDialog, setOpenVerifyDialog] = useState<boolean>(false);

  const handleVerifyDialog = () => {
    setOpenVerifyDialog(!openVerifyDialog);
  };

  const { openModal: handleChangeUsername } = useCreateModal({
    formType,
    formConfig: getProfileFormConfig({
      endpoint: ProfileEndpoint.CHANGE_USERNAME,
      schema: CHANGE_USERNAME_SCHEMA,
    })!,
    initialValues: {
      first_name: validateDataValue(userDetails?.first_name, '—'),
      last_name: validateDataValue(userDetails?.last_name, '—'),
    },
    handleSubmit: (values) => {
      dispatch(
        submitFormRequest({
          formType,
          formData: values,
          params: {
            content_id: application_id,
          },
          globalOptions: {
            endpoint: ProfileEndpoint.CHANGE_USERNAME,
          },
        }),
      );
    },
  });

  const { openModal: handleChangePassword } = useCreateModal({
    formType,
    formConfig: getProfileFormConfig({
      endpoint: ProfileEndpoint.CHANGE_PASSWORD,
      schema: CHANGE_PASSWORD_SCHEMA,
    })!,
    handleSubmit: (values) => {
      dispatch(
        submitFormRequest({
          formType,
          formData: values,
          params: {
            content_id: application_id,
          },
          globalOptions: {
            endpoint: ProfileEndpoint.CHANGE_PASSWORD,
          },
        }),
      );
    },
  });

  return (
    <div className="flex flex-1 flex-col gap-8">
      <Breadcrumbs />
      <div className="flex flex-col justify-between gap-5 sm:gap-8">
        <ProfileSettingsForm
          handleVerifyDialog={handleVerifyDialog}
          handleChangeUsername={handleChangeUsername}
          handleChangePassword={handleChangePassword}
        />

        <InformationModal
          title={tModals('emailVerified')}
          topTitle
          content={
            <Text $level={5} $customizeColor className="text-justify pt-1">
              {tModals('emailVerifiedDescription')}
            </Text>
          }
          onClose={handleVerifyDialog}
          open={openVerifyDialog}
        />
      </div>
    </div>
  );
};
